import React, { useState } from "react";
import infoIcon from "resources/images/info.svg";
import caretUp from "resources/images/caretUp@2x.png";
import caretDown from "resources/images/caret-down-grey.svg";

const Disclaimer = () => {
  const [disclaimerOpen, setDisclaimerOpen] = useState(false);

  const disclaimerActionText = disclaimerOpen ? (
    <span>
      Hide Disclaimer
      <img src={caretUp} width="16px" alt="caret-up" />
    </span>
  ) : (
    <span>
      Read more
      <img src={caretDown} width="16px" alt="caret-down" />
    </span>
  );

  return (
    <div className="help-assistant-disclaimer-text d-flex">
      <img
        height="16px"
        width="16px"
        src={infoIcon}
        alt="Info"
        className="mr-2"
        style={{ position: "relative", top: "3px" }}
      />
      <div>
        <p className="mb-1">
          By Submitting a question, you acknowledge and agree to the disclaimer.{" "}
          <button
            type="button"
            onClick={() => setDisclaimerOpen(!disclaimerOpen)}
            className="px-0"
            style={{ textDecoration: "underline", fontWeight: "700" }}
          >
            {disclaimerActionText}
          </button>
        </p>
        {disclaimerOpen ? (
          <p className="mb-1">
            {`We're not trying to fool anyone, the following content is being
        generated by Criteria's AI system. It may contain errors,
        inconsistencies, or outdated information. Our attorneys said we
        have to tell you it is being provided "as-is," which means
        without any warranties or guarantees of accuracy. So, we have to
        disclaim any liability for damages or losses resulting from the
        use or reliance on this content, despite our attempts to be as
        accurate and up-to-date as possible. Don't hesitate to contact
        one of our humans for further details or explanation on any of
        the AI system content.`}
          </p>
        ) : null}
      </div>
    </div>
  );
};

Disclaimer.propTypes = {};

export default Disclaimer;
